export function splitName(fullName: string) {
  const nameParts = fullName.trim().split(' ')

  const result: { first_name: string; last_name: string; other_name?: string } = {
    first_name: '',
    last_name: ''
  }

  if (nameParts?.length === 1) {
    result.first_name = nameParts[0]
  } else if (nameParts?.length === 2) {
    result.first_name = nameParts[0]
    result.last_name = nameParts[1]
  } else if (nameParts?.length > 2) {
    result.first_name = nameParts[0]
    result.last_name = nameParts[1]
    result.other_name = nameParts.slice(2).join(' ')
  }

  return result
}

export const capitalizeEachLetter = (arg: string) => {
  const letter = arg.split(' ')
  for (let i = 0; i < letter?.length; i++) {
    letter[i] = letter[i][0].toUpperCase() + letter[i].substr(1)
  }
  return letter.join(' ')
}

export const capitalizeDrugName = (value?: string | null, fallback = '-') => {
  if (!value) return fallback

  return value.replace(/\b[a-z]/g, letter => letter.toUpperCase())
}

export function capitalizeFirstLetter(sentence: string) {
  if (!sentence) return sentence // Return the original if it's empty
  return sentence.charAt(0).toUpperCase() + sentence.slice(1)
}
